import {
    SELECTED_TEAM_NAME_LIST_REQUEST,
    SELECTED_TEAM_NAME_LIST_SUCCESS,
    SELECTED_TEAM_NAME_LIST_ERROR,

    ADD_COACH_BULK_REQUEST,
    ADD_COACH_BULK_SUCCESS,
    ADD_COACH_BULK_ERROR,
} from "../../constants/BulkUpload/BulkUploadCoach.const";

const initialState = {
    teamListCoachReq: false,
    teamListCoachData: null,
    teamListCoachError: null,
    teamListCoachLoader: false,

    bulkCoachReq: false,
    bulkCoachData: null,
    bulkCoachError: null,
    bulkCoachLoader: false
};

export default function (state = initialState, action) {
    switch (action.type) {

        // For Select Team Name for this Coach
        case SELECTED_TEAM_NAME_LIST_REQUEST:
            return {
                ...state,
                teamListCoachReq: true,
                teamListCoachLoader: true,
            };
        case SELECTED_TEAM_NAME_LIST_SUCCESS:
            return {
                ...state,
                teamListCoachData: action.payload,
                teamListCoachLoader: true,
            };
        case SELECTED_TEAM_NAME_LIST_ERROR:
            return {
                ...state,
                teamListCoachError: action.error,
                teamListCoachLoader: true,
            };

        // Add bulk upload for coach
        case ADD_COACH_BULK_REQUEST:
            return {
                ...state,
                bulkCoachReq: true,
                bulkCoachLoader: true,
            };
        case ADD_COACH_BULK_SUCCESS:
            return {
                ...state,
                bulkCoachData: action.payload,
                bulkCoachLoader: true,
            };
        case ADD_COACH_BULK_ERROR:
            return {
                ...state,
                bulkCoachError: action.error,
                bulkCoachLoader: true,
            };

        default:
            return state;
    }
}